import { Icon, icons } from '../../../generic';
import type { Repository } from '../../../../types';

import ProjectRowBase from './ProjectRowBase';
import type { OnBranchChangeFn, OnImportRepositoryFn, OnSelectRepositoryFn } from './types';

import styles from './DisconnectedProjectRow.module.less';

type DisconnectedProjectRowProps = {
  repo: Repository;
  selectedRepos: Repository[];
  onBranchChange: OnBranchChangeFn;
  onSelectRepository: OnSelectRepositoryFn;
  onImportRepository: OnImportRepositoryFn;
};

const DisconnectedProjectRow = ({
  repo,
  selectedRepos,
  onBranchChange,
  onSelectRepository,
  onImportRepository,
}: DisconnectedProjectRowProps) => {
  const projectTypeLabel = repo.project?.type === 'autobuild' ? 'Quick Import' : 'CLI Import (Hybrid)';
  const status = (
    <span className={styles.connectionExplainer}>
      <Icon icon={icons.warning} />
      <span>
        This {projectTypeLabel} project has lost its connection to the FOSSA GitHub App. Import to reconnect.
      </span>
    </span>
  );

  return (
    <ProjectRowBase
      repo={repo}
      selectedRepos={selectedRepos}
      onBranchChange={onBranchChange}
      onSelectRepository={onSelectRepository}
      onImportRepository={onImportRepository}
      status={status}
      rowClassName={styles.row}
    />
  );
};

export default DisconnectedProjectRow;
